import React from 'react'
import { Box,CircularProgress, ThemeProvider } from '@mui/material';
import {theme} from '../theme'
function Loading() {
    return (
        <Box sx={{ display: 'flex' }}>
            <ThemeProvider theme={theme}>
          <CircularProgress  color="neutral"/>
          </ThemeProvider>
        </Box>
      );
}

export default Loading
